/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ meeting: NonNullable<unknown> }} Chat_Line_Meeting_ReportInputs */



/**
* | output |
* | --- |
* | "Report · {meeting}" |
*
* @param {Chat_Line_Meeting_ReportInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_line_meeting_report = /** @type {((inputs: Chat_Line_Meeting_ReportInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Line_Meeting_ReportInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Verslag · ${i?.meeting}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Compte rendu · ${i?.meeting}`)
	return /** @type {LocalizedString} */ (`Report · ${i?.meeting}`)
});